import { FC, PropsWithChildren } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'
import { LOGIN_ROUTE } from '../../constants/routing.constants'

export const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
    const auth = useAuth()
    if (auth.isLoading) {
        return <></>
    }
    if (!auth.isAuthenticated) {
        // user is not authenticated
        return <Navigate to={LOGIN_ROUTE} />
    }
    return children
}
